import * as redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mapTo'
import * as App from '../../app'
import * as Menu from '../../components/menu'
import * as RootConstants from '../../constants'
import * as Request from '../../request'
import {ApplicationState} from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'

export const onEnter = (
  action$: ReduxObservable.ActionsObservable<redux.Action>,
  store: redux.Store<ApplicationState>,
  {history, localStorage}: App.Dependencies,
) => action$.ofType(App.INITIALIZING_APPLICATION, Router.LOCATION_CHANGE)
  .filter(() => history.location.pathname.startsWith(Menu.AUTH_LOGOUT_URL))
  .filter(() => Boolean(localStorage.getItem(RootConstants.ACCESS_TOKEN)))
  .map(() => Actions.logoutUser())

export const onLogoutSuccess = (
  action$: ReduxObservable.ActionsObservable<redux.Action>,
  store: redux.Store<any>,
  {history, localStorage}: App.Dependencies,
) => action$.ofType(Request.successConstant(Constants.USER_LOGOUT))
  .map(() => localStorage.removeItem(RootConstants.ACCESS_TOKEN))
  .do(() => localStorage.removeItem(App.SELECTED_COMMUNITY))
  .mapTo(Router.redirect(Menu.AUTH_LOGIN_URL))

export const epic = ReduxObservable.combineEpics(
  onEnter,
  onLogoutSuccess,
)



// WEBPACK FOOTER //
// ./src/pages/logout/epic.ts